export const constantTooltip = {
    facebookTooltip: 'by page: https://www.facebook.com/cityofatlanta/, or by page name: @cityofatlanta',
    eventbriteTooltip: 'by page: https://www.eventbrite.com/o/trainerkart-americas-inc-11096725116',
    eventfulTooltip: 'by page: http://newyorkcity.eventful.com/venues/pnc-bank-arts-center-/V0-001-001467766-8',
    facebookString: 'facebook',
    eventbriteString: 'eventbrite',
    eventfulString: 'eventful'
};






// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/constants/constant.tooltip.ts